import { createSelector } from "reselect";
import { APPOINTMENT_TYPE } from "../consts";
import { deepGet } from "../../../utils";

const configSelector = state => state.config;
const bookingSelector = state => state.booking;
const appointmentSelector = state => state.appointment;
const dataSourceSelector = state => state.dataSource;

const getState = (config, booking, appointment, dataSource) => {
  const options = dataSource.appointmentTypes.sort((a, b) => {
    var nameA = a.description.toUpperCase(); // ignore upper and lowercase
    var nameB = b.description.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  const required = options.length !== 1;
  const value = required
    ? deepGet(appointment, [APPOINTMENT_TYPE])
    : options[0].appointmentTypeId;

  let text = "";
  if (value !== "") {
    const appointmentType = dataSource.appointmentTypes.find(
      a => a.appointmentTypeId === value
    );

    if (appointmentType) {
      text = appointmentType.description;
    }
  }
  return {
    text,
    value,
    options,
    required,
    hintText: config.appointmentTypeHintText,
    isOpen: booking.controlVisibility[APPOINTMENT_TYPE],
    completed: booking.completedSteps.includes(APPOINTMENT_TYPE),
    reload: booking.reload,
    preSelectPractitioner: config.preSelectPractitioner,
    practitionerFirst: config.practitionerFirst
  };
};

const appointmentTypeSelector = createSelector(
  configSelector,
  bookingSelector,
  appointmentSelector,
  dataSourceSelector,
  getState
);

export { appointmentTypeSelector };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/selectors/appointmentTypeSelector.js